import gql from 'graphql-tag';

export const gqlGetCollectionOrdersForStatuses = gql`
  query getCollectionOrders($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionOrders(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        statusId
        code
        orderedDate
        collectionpoint {
          id
          name
          addressArea
          addressCity
          phone
        }
        collector {
          id
          name
        }
        collectionOrderState {
          id
          name
        }
        plannedCollectionDate
      }
      recordCount
    }
  }
`;
